module.exports = __webpack_public_path__ + "static/media/unpin-icon.7d8c1b71.svg";